module.exports = __webpack_public_path__ + "static/media/phone-outlined.df468b07.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/phone-outlined.svg
// module id = 2246
// module chunks = 0